export default __webpack_public_path__ + "static/media/signup_blue.9184b8f8.png";